import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { getReserves, reservesSelector } from 'src/store/app';

import { SectionCard } from 'src/components';

import { REACT_APP_API_URL } from 'src/constants';

import './reserves.scss';

export const Reserves = () => {
  const { t, i18n } = useTranslation('reserves');

  const dispatch = useDispatch();

  const reserves = useSelector(reservesSelector);

  useEffect(() => {
    dispatch(getReserves());
  }, [dispatch, i18n.language]);

  return (
    <div className="reserves">
      <SectionCard title={t('title')}>
        <div className="reserves__content">
          {reserves?.map((item) => (
            <div key={item?.code} className="reserves__item">
              <div className="reserves__item__title">
                <div className="reserves__item__image">
                  <img
                    src={REACT_APP_API_URL + item?.image}
                    alt={REACT_APP_API_URL + item?.image}
                  />
                </div>
                <div>
                  {item.name} <span>({item?.code})</span>
                </div>
              </div>
              <div className="reserves__item__value">
                {item?.reserve} {item?.code}
              </div>
            </div>
          ))}
        </div>
      </SectionCard>
    </div>
  );
};
